import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Unknown.NotFoundScreen.title',
    defaultMessage: 'Сторінка не знайдена 😐',
  },
});
